import {createAction} from '@reduxjs/toolkit';

import type {Team} from '@mattermost/types/teams';

export const markAllThreadsReadInTeam = createAction<{
    teamId: Team['id'];
}>('threads/actions/markAllThreadsRead');
